<button class="mat-dialog-close" mat-dialog-close>
  <mat-icon svgIcon="close"></mat-icon>
</button>
<!-- Dialog: Header -->
<div class="mat-dialog-header">
  <h2>
    360* image viewer
  </h2>
</div>
<!-- Dialog: Content -->
<div class="mat-dialog-body">
  <ecp-image-data [name]="data.upc"></ecp-image-data>
</div>
<!-- Dialog: Footer/Actions -->
<div class="mat-dialog-footer" mat-dialog-actions>
  <div class="btn-group">

  </div>
</div>
